import { _ } from "../../polyglot/polyglot.js";
import { calendarAltIcon } from "../../elements/icons/index.js";
import { formatAsLongDate } from "../../helpers/date-formatting-util.js";
import { toNoon } from "../../helpers/date-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import datePickerWidget from "./datePickerWidget.js";

/**
 * `LastTransactionDatePickerWidget` is a section of `selectDataStepWidget`
 * to choose the import date range.
 */
export default class LastTransactionDatePickerWidget extends Widget {
	constructor() {
		super(...arguments);

		this._custom = false;
		this._lastTransactionDate = new Date();
		this._selectedDate = new Date();

		this._createEvents("onDateChanged");

		this._datePickerWidget = datePickerWidget();

		this._datePickerWidget.onDateChanged.register((date) => {
			this._selectedDate = date;
			this.onDateChanged.trigger(date);
		});
	}

	reset() {
		this._custom = false;
		this._lastTransactionDate = "";
		this._selectedDate = "";
	}

	setSelectableDates(timespan) {
		this._datePickerWidget.setRange(timespan);
		this.update();
	}

	setLastTransactionDate(date) {
		this._lastTransactionDate = date;
		this._selectedDate = date;
		this._datePickerWidget.setSelectedDate(date);
		this.update();
	}

	getSelectedDate() {
		if (this._custom) {
			return toNoon(this._selectedDate);
		}
		return toNoon(this._lastTransactionDate);
	}

	renderContentOn(html) {
		html.div(
			{
				klass: "form-group filter-data-to",
				"data-test": "last-transaction-date-picker",
			},
			html.label(
				{ klass: "control-label col-sm-4" },
				_("Import data until"),
			),
			html.div(
				{ klass: "col-sm-8 check-group" },
				html.label(
					{ change: this._hideCustom.bind(this) },
					html.input({
						klass: "form-control",
						type: "radio",
						name: "filter-data",
						value: "latest",
						checked: "checked",
					}),
					_("Last transaction date ({date})", {
						date: formatAsLongDate(this._lastTransactionDate),
					}),
				),
				html.label(
					{
						"data-test": "pick-a-date",
						change: this._showCustom.bind(this),
					},
					html.input({
						klass: "form-control",
						type: "radio",
						name: "filter-data",
						value: "custom",
					}),
					_("Pick a date"),
				),
				(html) => this._renderDatePickerOn(html),
			),
		);
	}

	_renderDatePickerOn(html) {
		html.div(
			{ klass: "custom-range" },
			html.div(
				{ class: "input-group" },
				html.span(
					{ klass: "input-group-addon inline-addon" },
					calendarAltIcon,
				),
				this._datePickerWidget,
			),
		);
	}

	_hideCustom() {
		this.asJQuery().find(".custom-range").hide();
		this._custom = false;
		this.onDateChanged.trigger(this.getSelectedDate());
	}

	_showCustom() {
		this.asJQuery().find(".custom-range").show();
		this._custom = true;
		this.onDateChanged.trigger(this.getSelectedDate());
	}
}
